import React, { useState, ReactElement, useEffect } from 'react'
import cn from 'classnames'
import s from './PromoBanner.module.scss'
import { useCookies } from 'react-cookie'

interface PromoBannerProps {
    maxAge?: number
    cookieName: string
    className?: string
    closeButton?: ReactElement | string
}

export const PromoBanner: React.FC<PromoBannerProps> = ({
    children,
    maxAge = 86400,
    cookieName,
    className,
    closeButton
}) => {
    // The useCookies argument is called "dependencies"
    // Whenever these cookies are updated from any component, this component will re-render
    const [cookies, setCookie] = useCookies([cookieName])

    // SSR-safe: mismo valor inicial en server y cliente; sync con cookie post-mount
    const [closed, setClosed] = useState(false)

    useEffect(() => {
        setClosed(!!cookies[cookieName])
    }, [cookies, cookieName])

    const handleClose = () => {
        setClosed(true)
        setCookie(cookieName, 'closed', {
            path: '/',
            maxAge: maxAge
        })
    }

    return (
        <div>
            {!closed && (
                <div className={cn(s['promo-banner'], className)}>
                    <div className={s['promo-banner-text']}>
                        {children}

                        <span
                            className={s['promo-banner-button']}
                            onClick={handleClose}
                            aria-hidden="true"
                        >
                            {closeButton}
                        </span>
                    </div>
                </div>
            )}
        </div>
    )
}
